module.exports = __webpack_public_path__ + "img/17874_L.8da9f79c.png";